import { useQuery, UseQueryResult } from 'react-query'

import { useShareService } from 'features/share/service'
import type { SharedUsersResponse } from 'features/share/types'

export function useSharedUsersQuery(
  projectId: string,
  enabled: boolean = true,
): UseQueryResult<SharedUsersResponse> {
  const shareService = useShareService()
  return useQuery(
    ['shared-users', projectId],
    () => shareService.fetchSharedUsers(projectId),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled,
    },
  )
}
